import React from 'react'

const SvgIconRevistas = ({ isClient, theme, ...props }) => (
	<svg width={22.009} height={29.163} {...props}>
		<defs>
			<style>{`.prefix__cls-2{fill: ${theme ? (!isClient ? theme.colors.white : theme.colors.primary) : ''}}}`}</style>
		</defs>
		<g id='prefix__Grupo_6285' data-name='Grupo 6285' transform='translate(5269.3 19530.333)'>
			<g id='prefix__Grupo_6284' data-name='Grupo 6284' transform='translate(-5269 -19530)'>
				<g id='prefix__magazine_1_' data-name='magazine (1)'>
					<g id='prefix__Grupo_6283' data-name='Grupo 6283'>
						<g id='prefix__Grupo_6282' data-name='Grupo 6282'>
							<path
								id='prefix__Caminho_5297'
								d='M20.935 2.363H5.666A2.855 2.855 0 000 2.839v23.312h.043a2.857 2.857 0 002.812 2.379h13.321a.476.476 0 00.476-.476v-1.427h4.283a.476.476 0 00.476-.476V2.838a.476.476 0 00-.476-.475zM.953 2.839a1.903 1.903 0 113.806 0v20.714a2.838 2.838 0 00-3.806 0zm14.748 24.74H2.855a1.9 1.9 0 111.9-1.9v.476a.476.476 0 00.476.476H15.7zm4.758-1.9H5.709V3.314h14.748z'
								data-name='Caminho 5297'
								fill={theme ? (!isClient ? theme.colors.white : theme.colors.primary) : ''}
								stroke={theme ? (!isClient ? theme.colors.white : theme.colors.primary) : ''}
								strokeWidth={0.6}
							/>
						</g>
					</g>
					<path
						id='prefix__Caminho_5302'
						d='M68.907 136h-8.285a.622.622 0 00-.622.622v6.284a.622.622 0 00.622.622h8.284a.622.622 0 00.622-.622v-6.284a.622.622 0 00-.621-.622zm-.622 6.284h-7.04v-5.04h7.04z'
						className='prefix__cls-2'
						data-name='Caminho 5302'
						transform='translate(-51.3 -131.177)'
					/>
				</g>
				<g id='prefix__Grupo_6286' data-name='Grupo 6286' transform='translate(.471 -.344)'>
					<path
						id='prefix__Caminho_5303'
						d='M219.907 136h-8.284a.622.622 0 000 1.244h8.284a.622.622 0 100-1.244z'
						className='prefix__cls-2'
						data-name='Caminho 5303'
						transform='translate(-202.871 -122.156)'
					/>
					<path
						id='prefix__Caminho_5304'
						d='M219.907 186h-8.284a.622.622 0 000 1.244h8.284a.622.622 0 000-1.244z'
						className='prefix__cls-2'
						data-name='Caminho 5304'
						transform='translate(-202.871 -169.045)'
					/>
					<path
						id='prefix__Caminho_5305'
						d='M219.907 236h-8.284a.622.622 0 000 1.244h8.284a.622.622 0 100-1.244z'
						className='prefix__cls-2'
						data-name='Caminho 5305'
						transform='translate(-202.871 -215.934)'
					/>
					<path
						id='prefix__Caminho_5306'
						d='M219.907 286h-8.284a.622.622 0 000 1.244h8.284a.622.622 0 100-1.244z'
						className='prefix__cls-2'
						data-name='Caminho 5306'
						transform='translate(-202.871 -262.822)'
					/>
				</g>
			</g>
		</g>
	</svg>
)

export default SvgIconRevistas
